export default __webpack_public_path__ + "static/media/undraw-social-sharing-ibwq.b69271e5.svg";